/**
 * WebhookEventsPage — `/webhooks/events`.
 *
 * The strip rides in the masthead via `host.listTabs`, so this page does not
 * own a `PageContainer`: `ResourcePage` owns the standard frame.
 *
 * `listTitle` is overridden to the SECTION name. The page used to be titled
 * "Webhook Events" — the active tab's own name — which left nothing on screen
 * naming the surface its tabs belong to.
 */

import { ResourcePage } from '@resource-kit/ui/react';
import { WebhooksTabs } from './WebhooksTabs';
import { webhookResource } from './webhookResource';

export default function WebhookEventsPage() {
  return (
    <ResourcePage
      bundle={{
        ...webhookResource,
        host: {
          ...webhookResource.host,
          listTitle: 'webhooks.pageTitle',
          listTabs: () => <WebhooksTabs />,
        },
      }}
    />
  );
}
